import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './bootstrap-custom.scss';
import { LoadingProvider } from './components/Loader/LoadingContext';
import Loading from './components/Loader/Loading';
import {
  initializeTelemetry,
  registerGlobalErrorHandlers,
} from './telemetry/applicationInsights';
import AppErrorBoundary from './components/ErrorBoundary/AppErrorBoundary';
import TelemetryTestPanel from './components/TelemetryTestPanel/TelemetryTestPanel';
import { trackMetric } from './telemetry/applicationInsights';

initializeTelemetry();
registerGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <LoadingProvider>
        <Loading />
        <App />
        <TelemetryTestPanel />
      </LoadingProvider>
    </AppErrorBoundary>
</React.StrictMode>,
);

if (process.env.REACT_APP_WEB_VITALS_TELEMETRY_ENABLED?.toLowerCase() === 'true') {
  reportWebVitals(metric => {
    trackMetric(`WebVital.${metric.name}`, metric.value, {
      metricId: metric.id,
      metricName: metric.name,
    });
  });
}
